module.exports = __webpack_public_path__ + "7d088296/img/archive-icon.0a6a9de3.svg";